import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  DxButtonModule,
  DxDataGridModule,
  DxPopupModule,
  DxRadioGroupModule,
  DxSelectBoxModule,
  DxTextBoxModule
} from 'devextreme-angular';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializer } from './app-init';
import { BuildConfigsComponent } from './build-configs/build-configs.component';
import { HeaderComponent } from './ui/header/header/header.component';
import { FooterComponent } from './ui/footer/footer.component';
import { LayoutComponent } from './ui/layout/layout.component';
import { BuildConfigsService } from './build-configs/build-configs.service';
import { UrlBuilderService } from './services/url-builder-service';
import { HttpClientModule } from '@angular/common/http';
import { BuildConfigComponent } from './build-configs/build-config.component';
import { BuildsService } from './build-configs/builds.service';
import { ReactiveFormsModule } from '@angular/forms';
import { DashboardsComponent } from './gitlab/dashboard/dashboards.component';
import { GitlabService } from './gitlab/gitlab.service';
import { DashboardComponent } from './gitlab/dashboard/dashboard.component';
import { RunnersComponent } from './gitlab/dashboard/runners/runners.component';
import { ActivePipelinesComponent } from './gitlab/dashboard/active-pipelines/active-pipelines.component';
import { TrackedBranchesComponent } from './gitlab/dashboard/tracked-branches/tracked-branches.component';
import { JiraService } from './build-configs/jira.service';
import { MergeRequestsComponent } from './gitlab/dashboard/merge-requests/merge-requests.component';
import { default as dxConfig } from 'devextreme/core/config';
import { licenseKey as dxLicenseKey} from '../devextreme-license'


export function init_app() {
  //
  // Load devextreme license
  //
  dxConfig({ licenseKey: dxLicenseKey });

  // Do initing of services that is required before app loads
  // NOTE: this factory needs to return a function (that then returns a promise)
  return () => {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LayoutComponent,
    BuildConfigsComponent, BuildConfigComponent, DashboardsComponent, DashboardComponent, RunnersComponent, ActivePipelinesComponent, TrackedBranchesComponent, MergeRequestsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    KeycloakAngularModule,
    DxDataGridModule,
    DxButtonModule,
    DxPopupModule,
    ReactiveFormsModule,
    DxTextBoxModule,
    DxRadioGroupModule,
    DxSelectBoxModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [KeycloakService]
    },
    UrlBuilderService, BuildConfigsService, BuildsService, GitlabService, JiraService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
